import type { ComponentSize } from '@zoryn/constants'
import { getGridRowHeight } from '../row-height'

/** body cell 水平内边距（单侧），与 theme-chalk `--z-grid-cell-padding-x` 对齐 */
export function resolveBodyCellPaddingX(size?: ComponentSize | null): number {
  if (size === 'large') {
    return 16
  }
  if (size === 'small') {
    return 8
  }
  return 12
}

/** 图片列缩略图边长，与行高尺寸档位对齐 */
export function resolveImageCellSize(size?: ComponentSize | null): number {
  const rowHeight = getGridRowHeight(size)
  if (size === 'small') {
    return Math.min(28, rowHeight - 8)
  }
  if (size === 'large') {
    return Math.min(44, rowHeight - 12)
  }
  return Math.min(36, rowHeight - 16)
}

/** checkbox / seq 列宽：复选框尺寸 + 两侧内边距 + 余量 */
export function resolveSpecialColumnWidth(size?: ComponentSize | null): number {
  const checkboxSize = size === 'small' ? 12 : 14
  const padding = resolveBodyCellPaddingX(size)
  return checkboxSize + padding * 2 + 2
}

/** header-cell padding: calc(cell-padding-x - 4px) * 2，与 theme-chalk grid 尺寸变量对齐 */
export function resolveHeaderCellPaddingX(size?: ComponentSize | null): number {
  if (size === 'large') {
    return 24
  }
  if (size === 'small') {
    return 8
  }
  return 16
}

export function resolveHeaderTitleFont(size?: ComponentSize | null): string {
  if (size === 'large') {
    return '600 16px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }
  if (size === 'small') {
    return '600 12px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }
  return '600 14px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
}
